import axios from "axios";
import { ENDPOINT } from "../ENDPOINT";

export const NotificationService = {
  getForUser: async (uid, name) => {
    const res = await axios.get(ENDPOINT.Notifications, {
      params: { uid: uid || "", name: name || "" },
    });
    return res.data;
  },
  create: async (data) => {
    const res = await axios.post(ENDPOINT.Notifications, data);
    return res.data;
  },
  markRead: async (id) => {
    const res = await axios.put(`${ENDPOINT.Notifications}/${id}/read`);
    return res.data;
  },
  remove: async (id) => {
    const res = await axios.delete(`${ENDPOINT.Notifications}/${id}`);
    return res.data;
  },

  removeByTarget: async (targetId) => {
    const res = await axios.delete(`${ENDPOINT.Notifications}/target/${targetId}`);
    return res.data;
  },
};